import { MS_PER } from '@/services/types/Time'
import type { Refresher } from '@/services/types/Refresher'

export default defineNuxtPlugin(() => {
  const user = useUserStore()
  const clerkAuth = useAuth()
  const { checkMemoryUsage } = useReportsStore()

  const legacyTokenRefresher: Refresher = {
    interval: undefined,
    enable () {
      this.interval = setInterval(() => {
        if (clerkAuth.isSignedIn.value) {
          this.disable()
          return
        }
        user.refreshLegacyToken()
      }, MS_PER.Minute * 2)
    },
    disable () {
      clearInterval(this.interval)
    }
  }
  if (!clerkAuth.isSignedIn.value) {
    legacyTokenRefresher.enable()
  }

  setInterval(() => {
    user.getUserInformation()
  }, MS_PER.Minute)

  setInterval(() => {
    checkMemoryUsage()
  }, MS_PER.Minute)
})
